import SignaturePad from 'signature_pad'
import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useSignaturePad(canvasRef) {
  const pad = ref(null)

  function resize() {
    const canvas = canvasRef.value
    if (!canvas) return
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)
    pad.value?.clear()
  }

  onMounted(() => {
    pad.value = new SignaturePad(canvasRef.value)
    resize()
    window.addEventListener('resize', resize)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', resize)
  })

  function clear() {
    pad.value?.clear()
  }

  function toDataURL() {
    return pad.value?.toDataURL()
  }

  function isEmpty() {
    return pad.value?.isEmpty() ?? true
  }

  return { isEmpty, clear, toDataURL }
}
